import React from 'react';
import search from './../../../assets/search.svg'
import './searchbtn.css'

const Search = () => {
    return ( <>
    <div className='btnCont'>
        <button className='searchbtn' type='Submit'>
    <img src={search} alt=''/>
    Search
</button>
    </div>
    </> );
}
 
export default Search;